import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
export const styles = {
  page: {
    kAzted: "xg6iff7",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "xl56j7k",
    kWkggS: "x16vpd03",
    kmVPX3: "xd1rx2h",
    $$css: true
  },
  card: {
    kzqmXN: "xh8yej3",
    ks0D6T: "x1lr1uin",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kaIpWk: "xgkqh4w",
    kGVxlE: "xfld9nz",
    kmVPX3: "xum75ri",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1uw14oh",
    $$css: true
  },
  header: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "xr8clws",
    $$css: true
  },
  title: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x19b9xl8",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  subtitle: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  body: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1bof9c1",
    $$css: true
  },
  message: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  error: {
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    kMwMTN: "x2wi9gy",
    kmVPX3: "xrqf348",
    kWkggS: "x8qqj1s",
    kaIpWk: "xxltkoq",
    $$css: true
  }
};